import { Burger } from '../core'

$.fn.Header = function() {
  let self = this

  if (self.data('header')) {
    return self.data('header')
  }

  self.burger = undefined
  self.cloned = undefined

  return function() {
    /* burger init */
    self.burger = new Burger('.burger', {
      onToggle: function() {
        if (self.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })

    /* Clone on mobile */
    if (self.hasClass('header--large')) {
      self.cloned = self.clone().removeClass('header--large')
      self.after(self.cloned)
      $.mlmi.scroller.add(function(top, direction) {
        if (direction == 'down' && top > 400) {
          self.cloned.addClass('header--fixed')
        } else if (direction == 'up' && top < $(window).height()) {
          self.cloned.removeClass('header--fixed')
        }
      })
    }

    /* Scroll behavior */
    self.data('header', self)
    return self
  }()
}
